/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ListingTypeBadge({ listingType }) {
  const { t } = useTranslation();
  const currentType = listingType || 'SALE';
  const isRent = currentType === 'RENT';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 16px',
        backgroundColor: isRent ? '#E3F2FD' : '#E7F7EF',
        borderRadius: '8px',
        minWidth: '80px',
      }}
    >
      <Typography
        sx={{
          color: isRent ? '#1976D2' : '#0CAF60',
          fontWeight: 700,
          fontSize: '10px',
          lineHeight: '16px',
        }}
        variant="subtitle2"
        textAlign="center"
        noWrap
      >
        {isRent ? t('reversationRequest.rent') : t('reversationRequest.sale')}
      </Typography>
    </Box>
  );
}
